import React from "react";

export default function WhoWeAre() {
  return (
    <main className="pt-24 pb-16 px-6 max-w-5xl mx-auto text-gray-700 leading-relaxed">
      <h1 className="text-3xl font-bold text-center mb-8">Who We Are</h1>

      <p className="mb-4">
        St. Stephen’s Church, Cumballa Hill, is a vibrant and faith-filled
        community under the Archdiocese of Bombay. Our mission is to live and
        share the message of Christ through prayer, service, and unity.
      </p>

      <p className="mb-4">
        Established in the early 1900s, our parish has been a home for countless
        families who have grown in faith together. From Sunday liturgies to
        outreach programs and youth gatherings, St. Stephen’s stands as a beacon
        of compassion and hope in South Mumbai.
      </p>

      <p className="mb-4">
        The parish is led by our dedicated clergy and supported by numerous
        parish councils, ministries, and lay volunteers who work tirelessly to
        build a stronger spiritual community.
      </p>

      <p>
        Whether you are a long-time parishioner or visiting for the first time,
        we invite you to become part of our growing family of faith and love.
      </p>
    </main>
  );
}
